module.exports = __webpack_public_path__ + "img/banner-prakerja.81dccecb.webp";